import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RXService from '@Services/RxService';
import { HEATMAP_OBSERVABLE_TOPICS, HEATMAP_SPLITTER_CHANGE_STATES } from '@Pages/Heatmap/constants';
import CommonHeaderCell from '@Pages/Heatmap/HeatmapTable/Header/CommonHeaderCell';

function CommonHeader({ viewOptions, settings }) {
  const [isVSplitterActivated, setIsVSplitterActivated] = useState(false);
  const [isVSplitterDragging, setIsVSplitterDragging] = useState(false);
  const [isHSplitterActivated, setIsHSplitterActivated] = useState(false);
  const [isHSplitterDragging, setIsHSplitterDragging] = useState(false);

  const verticalSplitterChanged = (state) => {
    if (state === HEATMAP_SPLITTER_CHANGE_STATES.moved) {
      setIsVSplitterActivated(false);
      setIsVSplitterDragging(true);
    } else if (state === HEATMAP_SPLITTER_CHANGE_STATES.released) {
      setIsVSplitterActivated(false);
      setIsVSplitterDragging(false);
    }
  };

  const horizontalSplitterChanged = (state) => {
    if (state === HEATMAP_SPLITTER_CHANGE_STATES.moved) {
      setIsHSplitterActivated(false);
      setIsHSplitterDragging(true);
    } else if (state === HEATMAP_SPLITTER_CHANGE_STATES.released) {
      setIsHSplitterActivated(false);
      setIsHSplitterDragging(false);
    }
  };

  const pushSplitterActivated = (event, topic) => {
    const splitterEl = event.target;
    const splitterParams = {
      top: splitterEl.offsetTop,
      left: splitterEl.offsetLeft,
      width: splitterEl.offsetWidth,
      height: splitterEl.offsetHeight,
    };

    RXService.next(topic, HEATMAP_SPLITTER_CHANGE_STATES.activated, {
      splitterParams,
      eventParams: event,
    });
  };

  const verticalSplitterActivated = (e) => {
    pushSplitterActivated(e, HEATMAP_OBSERVABLE_TOPICS.verticalSplitter);

    setIsVSplitterActivated(true);
    setIsVSplitterDragging(false);
  };

  const horizontalSplitterActivated = (e) => {
    pushSplitterActivated(e, HEATMAP_OBSERVABLE_TOPICS.horizontalSplitter);
    setIsHSplitterActivated(true);
    setIsHSplitterDragging(false);
  };

  useEffect(() => {
    const rxSubscriptions = [
      RXService.subscribe(HEATMAP_OBSERVABLE_TOPICS.verticalSplitter, verticalSplitterChanged),
      RXService.subscribe(HEATMAP_OBSERVABLE_TOPICS.horizontalSplitter, horizontalSplitterChanged),
    ];
    return () => {
      rxSubscriptions.forEach((rxSubscription) => rxSubscription.unsubscribe());
    };
  }, []);

  return (
    <div
      className={classnames('heatmap__common-headers', {
        'splitter-h-active': isHSplitterActivated,
        'splitter-v-active': isVSplitterActivated,
        'splitter-h-dragging': isHSplitterDragging,
        'splitter-v-dragging': isVSplitterDragging,
      })}
      style={{
        height: viewOptions.colsHeaderHeight,
        width: viewOptions.rowsHeaderWidth,
      }}>
      {/* Horizontal label */}
      <div className="heatmap__common-headers__horizontal-container">
        <CommonHeaderCell className="heatmap__common-headers__horizontal-item" headerName={settings.row.title} />
      </div>
      {/* Vertical label */}
      <div className="heatmap__common-headers__vertical-container">
        <CommonHeaderCell
          className="heatmap__common-headers__vertical-item"
          headerName={settings.col.title}
          style={{
            width: `calc(${viewOptions.colsHeaderHeight}px - 2rem)`,
          }}
        />
      </div>
      {/* Vertical resize */}
      {!isVSplitterActivated && !isVSplitterDragging ? (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div className="heatmap__common-headers__vertical-splitter-activator" onMouseDown={verticalSplitterActivated} />
      ) : null}
      {/* Horizontal resize */}
      {!isHSplitterActivated && !isHSplitterDragging ? (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div className="heatmap__common-headers__horizontal-splitter-activator" onMouseDown={horizontalSplitterActivated} />
      ) : null}
    </div>
  );
}

CommonHeader.propTypes = {
  viewOptions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};

export default CommonHeader;
